import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { auroraCardMotion } from './motion';
import { auroraChromeTone } from './palette';

export const auroraTheme: FlowThemeDefinition = {
  id: 'aurora',
  label: 'Aurora',
  description: 'A lantern lights across a frozen lake for each question as the northern lights ignite overhead, ending in a blazing corona.',
  category: 'night',
  chromeTone: auroraChromeTone,
  swatch: 'linear-gradient(180deg, #040A22 0%, #0B3A4C 45%, #3CE6A0 72%, #B45CE8 100%)',
  cardGlass: 'dense',
  cardMotion: auroraCardMotion,
  burstSize: 320,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createAuroraScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
